export enum WeddingCakeLayers {
	OneLayer = "OneLayer",
	TwoLayers = "TwoLayers",
	ThreeLayers = "ThreeLayers",
	More = "More",
}
